<template>
  <div class="app">
    <slot />
  </div>
</template>
<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {};
  },
});
</script>

<style lang="scss">
@import './styles/carbon.scss';
@import './styles/styles.scss';
</style>
<!-- Load Google Fonts -->
<script src="https://ajax.googleapis.com/ajax/libs/webfont/1.5.10/webfont.js"></script>
<script lang="js">
var WebFont = require('webfontloader');
WebFont.load({
  google: {
    families: ['Roboto', 'Open Sans', 'Montserrat', 'Poppins', 'Nunito', 'Source Sans Pro',
    'Oxygen', 'Sora', 'Hahmlet', 'Andada Pro', 'Epilogue', 'JetBrains Mono', 'Inter', 'Encode Sans',
    'Manrope', 'Lora', 'Playfair Display', 'Archivo', 'Oswald', 'Cormorant'],
  },
});
</script>
